import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { StyledNormalDescription, getQuestionScoreValue } from './base-question-ai-change-preview.strategy';
import { jsx as _jsx } from "react/jsx-runtime";
export var AiAddQuestionChangeStrategy = /*#__PURE__*/function () {
  function AiAddQuestionChangeStrategy(context) {
    _classCallCheck(this, AiAddQuestionChangeStrategy);

    this.context = context;
  }

  _createClass(AiAddQuestionChangeStrategy, [{
    key: "renderBadgeIcon",
    value: function renderBadgeIcon() {
      return /*#__PURE__*/_jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z"
        })
      });
    }
  }, {
    key: "renderBadgeLabel",
    value: function renderBadgeLabel() {
      var _this$context$label$b;

      return /*#__PURE__*/_jsx("span", {
        children: (_this$context$label$b = this.context.label.badgeNew) !== null && _this$context$label$b !== void 0 ? _this$context$label$b : 'NEW'
      });
    }
  }, {
    key: "renderDescription",
    value: function renderDescription() {
      var _this$context$after, _this$context$after2;

      if (!((_this$context$after = this.context.after) !== null && _this$context$after !== void 0 && _this$context$after.description)) {
        return null;
      }

      return /*#__PURE__*/_jsx(StyledNormalDescription, {
        value: (_this$context$after2 = this.context.after) === null || _this$context$after2 === void 0 ? void 0 : _this$context$after2.description
      });
    }
  }, {
    key: "renderScore",
    value: function renderScore() {
      return getQuestionScoreValue(this.context.after);
    }
  }, {
    key: "renderExplanation",
    value: function renderExplanation() {
      var _this$context$after3, _this$context$after4;

      if (!((_this$context$after3 = this.context.after) !== null && _this$context$after3 !== void 0 && _this$context$after3.explanation)) {
        return null;
      }

      return /*#__PURE__*/_jsx(StyledNormalDescription, {
        value: (_this$context$after4 = this.context.after) === null || _this$context$after4 === void 0 ? void 0 : _this$context$after4.explanation
      });
    }
  }]);

  return AiAddQuestionChangeStrategy;
}();